/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';
//import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions/';
import * as DataServiceEntities from './DataServiceEntities.g';
import { mWPEcomCreateQuotationAsync } from './DataActionExtension.g';

/**
 * CreateQuotation Input Action
 */
export class CreateQuotationInput implements Msdyn365.IActionInput {
    //private readonly apiSettings?: Msdyn365.ICommerceApiSettings;
    public readonly createQuoteHeaderEntity?: DataServiceEntities.IMWPCreateQuotHeaderEntity;
    //private entity = this.createQuoteHeaderEntity;
    constructor(createQuoteHeaderEntity: DataServiceEntities.IMWPCreateQuotHeaderEntity) {
        this.createQuoteHeaderEntity = createQuoteHeaderEntity;
    }
    public getCacheKey = (): string => 'Quotation';
    public getCacheObjectType = (): string => 'Quotations';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}
/**
 * Validates the user's authentication and returns `CreateQuotationInput`
 * @throws Error if the user is not authenticated
 */
const createGetQuotationsInput = (
    user: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>,
    inputData: DataServiceEntities.IMWPCreateQuotHeaderEntity
): Msdyn365.IActionInput => {
    if (!user.requestContext.user.isAuthenticated) {
        throw new Error('Unable to fulfill request. User is not authenticated.');
    }
    return new CreateQuotationInput(inputData);
};
/**
 * Action to create a quotation by calling `mWPEcomCreateQuotationAsync`
 */
export async function tasCreateQuotationaction(
    input: CreateQuotationInput,
    ctx: Msdyn365.IActionContext
): Promise<DataServiceEntities.IMWPEcomCreateQuotResponse> {
    const entity = input.createQuoteHeaderEntity;
    if (!entity) {
        return Promise.reject('Input data not provided');
    }
    return mWPEcomCreateQuotationAsync({ callerContext: ctx, bypassCache: 'getAndPut' }, entity);
}
export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<DataServiceEntities.IMWPEcomCreateQuotResponse>>tasCreateQuotationaction,
    id: 'TASCreateQuotation',
    input: createGetQuotationsInput
});
